IN.App.LoginController = Ember.Controller.extend(IN.SmsVerificationHelper, {

	needs: ['smsverification'],
	password: null,
	email: null,
	tooltiperror: "",
	error: false,
	loading: false,

	init: function() {
		IN.App.TokenHelper.flush();
	},

	actions: {
		login: function(){
			var self = this,
				smsverificationController = this.get('controllers.smsverification');

			var data = {
				email: self.get('email'),
				password: self.get('password')
			}

			if (DEMO) {
				var data = {
					email: "demo@bydehand.eu",
					password: "demo1234"
				}
			}

			if(!data.email || !data.password) return;

			self.set('loading', true);

			$.post("/v1/auth/login", JSON.stringify(data), function(response) {

				if(response.status == 'success' && response.method == 'sms'){
					if(response.user && response.user.two_step_auth == 0) {
						IN.App.TokenHelper.set(response.token);
						window.location.href = window.location.search ? '/#/' + window.location.search : '/#/';
					} else {
						smsverificationController.set('sms_tracked', false);

						// check the token for its ava
						self.checkSMSDeliveryStatus(response.plivo_id, function(intervalResponse) {
							smsverificationController.set('sms_tracking_message', intervalResponse.message);
						}).then(function(response) {
							// delivered
							smsverificationController.set('sms_tracked', true);
							smsverificationController.set('sms_tracking_message', response.message);
						}, function(response) {
							// not delivered
							smsverificationController.set('sms_tracked', true);
							smsverificationController.set('sms_tracking_message', response.message);
						});

						self.transitionToRoute("smsverification");
					}
				}
				if(response.status == 'success' && response.method == 'call'){
					self.transitionToRoute("cellverification");
				}
				if(response.status == 'error'){
					// self.set('error', true);
					self.set('tooltiperror', "Email en wachtwoord komen niet overeen.");
					self.get('view').send('showTooltip');
				}

				self.set('loading', false);

			}, "json");
		},

		login_facebook: function() {

			var self = this;

			if(window.FB) {
				FB.login(function(response) {
					if(response.authResponse) {
						// user authorized the login!

						Em.$.post('/v1/auth/facebook', JSON.stringify(response.authResponse)).then(function(res) {

							if(typeof res === 'object') {
								if(res.status === "success") {
									IN.App.TokenHelper.set(res.token);
									window.location.href = window.location.search ? '/#/' + window.location.search : '/#/';
								} else {
									self.set('tooltiperror', res.message);
									self.get('view').send('showTooltip');
								}
							} else {
								self.set('tooltiperror', 'Er ging wat mis! Probeer het later nog eens.');
								self.get('view').send('showTooltip');

								FB.logout(function(response) {});

							}

						}, function(err) {
							self.set('tooltiperror', 'Inloggen met Facebook niet gelukt! Probeer een reguliere inlog of probeer het later opnieuw.');
							self.get('view').send('showTooltip');
						});
					}
				});
			} else {
				self.set('tooltiperror', 'Deze facebookdienst is door onbekende oorzaak tijdelijk niet beschikbaar.');
				self.get('view').send('showTooltip');
			}

		}

	},

	/*
	 *	Called by the view when google returned success on sign in
	 */
	googleSigninSuccess: function(user) {

		var self 		= this;
		var auth 		= user.getAuthResponse();
		var userId 		= user.getId();
		var accessToken = auth.access_token;
		var idToken 	= auth.id_token;

		// send request to backend
		Em.$.post('/v1/auth/google', JSON.stringify({
			access_token: accessToken,
			id_token: idToken,
			user_id: userId
		})).then(function(response) {

			if(response.status === 'success') {
				IN.App.TokenHelper.set(response.token);
				window.location.href = window.location.search ? '/#/' + window.location.search : '/#/';
			} else {
				user.disconnect();
				self.set('tooltiperror', response.message);
				self.get('view').send('showTooltip');
			}

		}, function(err) {

			self.googleSigninFailure(err);

		});

	},

	/*
	 *	Called by the view when google returned an error on sign in
	 */
	googleSigninFailure: function(error) {
		this.set('tooltiperror', 'Kon niet inloggen met google+ door een onbekende reden. Probeer het later opnieuw.');
		this.get('view').send('showTooltip');
	}
});
